// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3fG2J","paramInput":"JobSimulator_paramInput__3nbnr","input":"JobSimulator_input__1JFrG"};